import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const faqsApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFaqTypes: builder.mutation({
      query: () => ({
        url: `/faqs/get`,
        method: "GET",
      }),
    }),
    getFaqList: builder.mutation({
      query: (data: any) => ({
        url: `/faqs/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getUserGuidesForClient: builder.mutation({
      query: (data: { isActive: boolean }) => ({
        url: `/userguides/getuserguidesforclient?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getUserGuideById: builder.mutation({
      query: (data: any) => ({
        url: `/userguides/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
  }),
});


export const {
  useGetFaqTypesMutation,
  useGetFaqListMutation,
  useGetUserGuidesForClientMutation,
  useGetUserGuideByIdMutation,
} = faqsApiSlice;